import { openStream, request } from './client';
import type { RtInfo, RtSample } from '../types';

/** A well's real-time feed. Contract: docs/api/RT.md. */
export const rtApi = {
  /** 404 for a well without a feed. */
  info: (wellId: number) => request<RtInfo>(`/wells/${wellId}/rt`),

  history: async (wellId: number, minutes: number, points = 1500) =>
    (await request<{ samples: RtSample[] }>(`/wells/${wellId}/rt/history?minutes=${minutes}&points=${points}`))
      .samples,

  /**
   * Reads the stream until it ends or signal aborts, handing each sample to
   * onSample. since (unix ms) asks for what came after it first.
   */
  stream: async (wellId: number, since: number | null, onSample: (s: RtSample) => void, signal: AbortSignal) => {
    const res = await openStream(`/wells/${wellId}/rt/stream${since ? `?since=${since}` : ''}`, signal);
    const reader = res.body!.pipeThrough(new TextDecoderStream()).getReader();
    let pending = '';
    for (;;) {
      const { value, done } = await reader.read();
      if (done) return;
      pending += value;
      // Events end with a blank line; a comment line (": ping") carries nothing.
      let end: number;
      while ((end = pending.indexOf('\n\n')) >= 0) {
        const event = pending.slice(0, end);
        pending = pending.slice(end + 2);
        const data = event
          .split('\n')
          .filter((line) => line.startsWith('data: '))
          .map((line) => line.slice(6))
          .join('\n');
        if (data) onSample(JSON.parse(data) as RtSample);
      }
    }
  },
};
